import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import _asyncToGenerator from "/home/runner/work/digital-chamada/digital-chamada/frontend/digital-chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _defineProperty from "/home/runner/work/digital-chamada/digital-chamada/frontend/digital-chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import _regeneratorRuntime from "/home/runner/work/digital-chamada/digital-chamada/frontend/digital-chamada-frontend/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.regexp.split.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RequestService, { methodRequest } from "../services/RequestService";
import { mapMutations, mapState } from "vuex";
import Loading from 'quasar/src/plugins/Loading.js';import Notify from 'quasar/src/plugins/Notify.js';;
import { colors } from "../css/colors";
import DialogCustomMessage from "../components/dialog-custom-messages.vue";
import DialogSelectMessage from "../components/dialog-select-message.vue";
var DEFAULT = "Padrão";
var loading = function loading(message) {
  return Loading.show({
    message: message,
    backgroundColor: "white",
    customClass: "loading-class",
    spinnerColor: "primary",
    messageColor: "black"
  });
};
export default {
  name: "cliente",
  components: {
    DialogCustomMessage: DialogCustomMessage,
    DialogSelectMessage: DialogSelectMessage
  },
  data: function data() {
    return {
      panels: [],
      requestService: new RequestService(),
      clienteId: 0,
      title: "CONFIGURAÇÕES",
      allVideos: [],
      cliente: {
        nome: "Cliente",
        pathLogo: ""
      },
      titleActionForm: "Multimídia",
      formPainel: ["new-painel", "edit-painel", "multimidia"],
      codeCallingTextHandler: [],
      nameCallingTextHandler: [],
      placeNames: [],
      typeCallMessage: "",
      showMenuSize: false,
      showModalYoutube: false,
      showCodePicker: false,
      showNamePicker: false,
      showLocalPicker: false,
      showCustomMessageDialog: false,
      painel: {
        footerTextSize: 12,
        id: "",
        panelName: "",
        panelChannel: "",
        panelText: "",
        codeCallingText: "",
        nameCallingText: "",
        placeName: "",
        primaryColor: "",
        secondaryColor: "",
        clienteId: 0,
        prioritaryColor: "#9D0000",
        formPainel: false
      },
      painelVoiceOptions: ["Camila", "Vitoria", "Ricardo"],
      midiaConfig: {
        id: "",
        panelTextActive: false,
        soundPanel: "",
        volume: 0,
        volumeBeep: 0,
        timeToReturnVideo: 0,
        timeToSpeak: 0,
        activateVideo: false,
        painelId: "",
        panelVoice: ""
        // activateBeep: false,
      },

      soundPanelOptions: ["SomPainel1.mp3", "SomPainel2.mp3", "SomPainel3.mp3", "SomPainel4.mp3", "SomPainel5.mp3", "SomPainel6.mp3", "SomPainel7.mp3", "SomPainel8.mp3", "SomPainel9.mp3", "SomPainel10.wav", "SomPainel11.wav", "SomPainel12.wav"],
      showFormNewPainel: false,
      showFormEditPainel: false,
      showFormMultimidia: true,
      isMobile: false,
      logo: null,
      youtube: {
        isPlaylist: false,
        uri: ''
      }
    };
  },
  mounted: function mounted() {
    var _this = this;
    loading("<h5>Carregando configurações</h5>");
    this.clienteId = this.$route.params.cliente;
    this.getMessages(this.clienteId);
    this.getPlaceNames(this.clienteId);
    this.getPanels();
    this.getLogo();
    this.getVideos();
    this.setNamePainelDelete("");
    this.setTitle("CONFIGURAÇÕES");
    this.checkSizeScreen();
    this.initColorPicker();
    this.$root.$on("hide-dialog", function () {
      return _this.showCustomMessageDialog = false;
    });
    this.$root.$on("saving-message", function (condition, messageObj) {
      return _this.eventSavingData(condition, messageObj);
    });
  },
  computed: _objectSpread(_objectSpread({}, mapState("vuex_module", ["namePainelDelete"])), {}, {
    getColors: function getColors() {
      return colors;
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapMutations("vuex_module", ["setTitle", "setNamePainelDelete"])), {}, {
    getPanels: function getPanels() {
      var _this2 = this;
      if (Loading.isActive) {
        Loading.hide();
        loading("<h5>Carregando paineis...</h5>");
      }
      this.requestService.getPanels(this.clienteId).then(function (_ref) {
        var data = _ref.data;
        data.footerTextSize = 12;
        _this2.panels = data;
        if (_this2.panels.lenght > 0) {
          _this2.panels.forEach(function (e) {
            for (var _i = 0, _Object$keys = Object.keys(e.configStylesPainel); _i < _Object$keys.length; _i++) {
              var key = _Object$keys[_i];
              if (e.configStylesPainel[key].includes("{")) {
                e.configStylesPainel[key] = JSON.parse(e.configStylesPainel[key]);
              }
            }
          });
        }
        Loading.hide();
      }).catch(function (_ref2) {
        var data = _ref2.data;
        _this2.createNotify("negative", data.message);
      });
    },
    getMidiaConfig: function getMidiaConfig(painelId) {
      var _this3 = this;
      if (Loading.isActive) {
        Loading.hide();
        loading("<h5>Carregando configurações de midia...</h5>");
      }
      this.requestService.getMidiaConfig(painelId).then(function (_ref3) {
        var data = _ref3.data;
        _this3.midiaConfig = data;
        Loading.hide();
      }).catch(function (_ref4) {
        var data = _ref4.data;
        _this3.createNotify("negative", data.message);
      });
    },
    createNotify: function createNotify(type, message) {
      Notify.create({
        color: type,
        type: type,
        textColor: "white",
        message: message,
        position: "top"
      });
    },
    checkSizeScreen: function checkSizeScreen() {
      var mobileSize = 700;
      if (window.outerWidth < mobileSize) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },
    controlDisplayForms: function controlDisplayForms(formToShow, painelName) {
      document.querySelector(".form-new-painel").scroll(0, 0);
      this.showFormNewPainel = false;
      this.showFormEditPainel = false;
      this.showFormMultimidia = false;
      switch (formToShow) {
        case this.formPainel[0]:
          this.titleActionForm = "Novo Painel";
          this.showFormNewPainel = true;
          this.painel = {};
          this.midiaConfig = {};
          break;
        case this.formPainel[1]:
          this.getPanels();
          this.painel = this.panels.filter(function (p) {
            return p.panelName === painelName;
          })[0];
          this.getMidiaConfig(this.painel.id);
          this.showFormEditPainel = true;
          this.titleActionForm = painelName;
          this.showFormNewPainel = true;
          break;
        default:
          this.titleActionForm = "Miltimídia";
          this.showFormMultimidia = true;
          break;
      }
    },
    selectedSoundPainel: function selectedSoundPainel(soundIndex, listSound) {
      if (listSound === "sounds") {
        this.midiaConfig.soundPanel = this.soundPanelOptions[soundIndex];
        this.showAndHideSubMenu(".lsounds");
      } else {
        this.midiaConfig.panelVoice = this.painelVoiceOptions[soundIndex];
        this.showAndHideSubMenu(".lvoices");
      }
      this.$forceUpdate();
    },
    captureDialogCallext: function captureDialogCallext(object) {
      if (object.dest === "callByName") {
        this.painel.nameCallingText = object.val;
        this.showNamePicker = false;
      } else if (object.dest === "callByCode") {
        this.painel.codeCallingText = object.val;
        this.showCodePicker = false;
      } else if (object.dest === "placeName") {
        this.painel.placeName = object.val;
        this.showLocalPicker = false;
      } else {
        return;
      }
      this.$forceUpdate();
    },
    showAndHideSubMenu: function showAndHideSubMenu(classElement) {
      var clasToShowMenu = "expand-height";
      var element = document.querySelector(classElement);
      if (element) {
        element.classList.contains(clasToShowMenu) ? element.classList.remove(clasToShowMenu) : element.classList.add(clasToShowMenu);
      }
    },
    showAndHideSubMenuColor: function showAndHideSubMenuColor(classElement, subElement) {
      var clasToShowMenu = "expand-height";
      var element = document.querySelector(classElement);
      var subElemntColor = document.querySelector(subElement);
      if (element.classList.contains(clasToShowMenu)) {
        element.classList.remove(clasToShowMenu);
        subElemntColor.style.height = "0";
      } else {
        element.classList.add(clasToShowMenu);
        subElemntColor.style.height = "15vh";
      }
    },
    getVideos: function getVideos() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this4.requestService.getAllVideos(_this4.clienteId);
            case 2:
              _this4.allVideos = _context.sent;
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    deleteVideo: function deleteVideo(nameVideo) {
      var _this5 = this;
      loading("<h5>Deletando video: ".concat(nameVideo, ". Aguarde...</h5>"));
      this.requestService.deleteVideo(nameVideo, this.clienteId).then(function (e) {
        _this5.createNotify("positive", "Video deletado com sucesso");
        _this5.getVideos();
        Loading.hide();
      }).catch(function (_ref5) {
        var data = _ref5.data;
        _this5.createNotify("negative", data.message);
      });
    },
    deleteVideoYoutube: function deleteVideoYoutube(video) {
      var _this6 = this;
      loading("<h5>Deletando video: ".concat(video.uri, ". Aguarde...</h5>"));
      this.requestService.deleteVideoYoutube(video.code).then(function (e) {
        _this6.createNotify("positive", "Video deletado com sucesso");
        _this6.getVideos();
        Loading.hide();
      });
    },
    getMessages: function getMessages(clientId) {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _yield$_this7$request, data;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this7.requestService.getCallMessages(clientId);
            case 2:
              _yield$_this7$request = _context2.sent;
              data = _yield$_this7$request.data;
              data.forEach(function (e) {
                if (e.callBy === "code") {
                  _this7.codeCallingTextHandler.push(e);
                } else {
                  _this7.nameCallingTextHandler.push(e);
                }
              });
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getPlaceNames: function getPlaceNames(clientId) {
      var _this8 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _yield$_this8$request, data;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this8.requestService.getAllPlaces(clientId);
            case 2:
              _yield$_this8$request = _context3.sent;
              data = _yield$_this8$request.data;
              console.info(data);
              _this8.placeNames = data;
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    is_empty: function is_empty(object_string) {
      if (!object_string || object_string.lenght === 0 || !object_string.trim()) {
        return true;
      }
      return false;
    },
    savePainelAndMedia: function savePainelAndMedia() {
      var _this9 = this;
      var isQuietly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (!isQuietly) {
        if (this.is_empty(this.painel.panelChannel) || this.is_empty(this.painel.panelName) || this.is_empty(this.painel.placeName)) {
          this.createNotify("negative", "Todos os campos devem ser preenchidos!");
          return;
        }
        if (this.painel.id === "") {
          this.panels.forEach(function (e) {
            if (_this9.painel.panelChannel.trim() == e.panelChannel.trim()) {
              _this9.createNotify("negative", "Esse canal já está sendo utilizado, favor criar um novo!");
              throw Error("Canal já existe");
            }
            if (_this9.painel.panelName.toUpperCase().trim() == e.panelName.toUpperCase().trim()) {
              _this9.createNotify("negative", "Esse Nome já está sendo utilizado, favor criar um novo!");
              throw Error("Nome já existe");
            }
          });
        }
        if (!this.painel.codeCallingText || !this.painel.nameCallingText) {
          this.createNotify("negative", "Os campos das mensagens não pode ser nulo!");
          return;
        }
        loading("<h5>Salvando painel...</h5>");
      }
      this.showMenuSize = false;
      var method = this.showFormEditPainel ? methodRequest.PUT : methodRequest.POST;
      var fullObj = {
        id: this.painel.id,
        panelName: this.painel.panelName,
        panelChannel: this.painel.panelChannel,
        panelText: this.painel.panelText,
        codeCallingText: this.painel.codeCallingText,
        nameCallingText: this.painel.nameCallingText,
        placeName: this.painel.placeName,
        clienteId: this.$route.path.split("/")[1],
        panelTextActive: this.midiaConfig.panelTextActive,
        soundPanel: this.midiaConfig.soundPanel,
        volume: this.midiaConfig.volume,
        volumeBeep: this.midiaConfig.volumeBeep,
        timeToReturnVideo: this.midiaConfig.timeToReturnVideo,
        timeToSpeak: this.midiaConfig.timeToSpeak,
        activateVideo: this.midiaConfig.activateVideo,
        panelVoice: this.midiaConfig.panelVoice,
        configStylesPainel: this.painel.configStylesPainel
      };
      this.requestService.savePainelAndMedia(method, this.clienteId, fullObj, this.painel.id).then(function (_ref6) {
        var data = _ref6.data;
        if (!isQuietly) {
          _this9.controlDisplayForms(_this9.formPainel[2]);
          _this9.createNotify("positive", "Salvo com sucesso");
        }
        _this9.getPanels();
        _this9.midiaConfig = {};
      }).catch(function (_ref7) {
        var data = _ref7.data;
        _this9.createNotify("negative", data.message);
      });
    },
    deletePainel: function deletePainel(painel) {
      var _this10 = this;
      this.setNamePainelDelete({
        name: this.painel.panelName,
        show: true
      });
      var deleteRequest = setInterval(function () {
        if (_this10.namePainelDelete.hasOwnProperty("delete") && _this10.namePainelDelete.delete) {
          clearInterval(deleteRequest);
          loading("<h5>Excluindo painel ".concat(_this10.painel.panelName, "...</h5>"));
          _this10.requestService.deletePainel(_this10.clienteId, painel.id).then(function (_ref8) {
            var data = _ref8.data;
            _this10.setNamePainelDelete(_this10.painel.painelName);
            _this10.controlDisplayForms(_this10.formPainel[2]);
            _this10.getPanels();
            Loading.hide();
          }).catch(function (_ref9) {
            var data = _ref9.data;
            _this10.createNotify("negative", data.message);
          });
        }
      }, 500);
    },
    saveMidia: function saveMidia(painelId) {
      var _this11 = this;
      var method = this.showFormEditPainel ? methodRequest.PUT : methodRequest.POST;
      this.requestService.saveMidiaConfig(method, painelId, this.midiaConfig).then(function (e) {}).then(function (err) {
        _this11.createNotify("negative", err.data.message);
      });
    },
    goToPainelConfig: function goToPainelConfig(painel) {
      this.$router.push("/".concat(this.clienteId, "/paineis/").concat(painel.id));
    },
    goToPainelPage: function goToPainelPage(painel) {
      this.$router.push("/".concat(this.clienteId, "/painel/").concat(painel.panelChannel));
      this.setTitle(painel.panelName);
    },
    getClient: function getClient() {
      var tempPath = this.$route.fullPath.split("/");
      this.clienteId = tempPath[1];
    },
    getLogo: function getLogo() {
      var _this12 = this;
      this.requestService.getLogo(this.clienteId).then(function (_ref10) {
        var data = _ref10.data;
        return fetch(data).then(function (res) {
          return res.status === 200 ? _this12.logo = data : "";
        });
      }).catch(function (_ref11) {
        var data = _ref11.data;
        _this12.createNotify("negative", data.message);
      });
    },
    uploadVideo: function uploadVideo(e) {
      var _this13 = this;
      if (e.target.files[0].type !== "video/mp4") {
        this.createNotify("negative", "Formato de video inválido, permitido somente video .mp4");
        return;
      }
      if (e.target.files[0].size > 50000000) {
        this.createNotify("negative", "O tamanho do arquivo não pode ser maior que 50mb");
        return;
      }
      loading("<h5>Carregando video. Aguarde...</h5>");
      this.requestService.uploadVideos(this.clienteId, e.target.files[0]).then(function (e) {
        _this13.getVideos();
        _this13.createNotify("positive", "Enviado com sucesso!");
        Loading.hide();
      }).catch(function (_ref12) {
        var data = _ref12.data;
        _this13.createNotify("negative", data.message);
      });
    },
    uploadLogo: function uploadLogo(e) {
      var _this14 = this;
      if (e.target.files[0].type !== "image/png") {
        this.createNotify("negative", "Formato de imagem inválido, permitido somente imagem .png");
        return;
      }
      loading("<h5>Carregando Logo. Aguarde...</h5>");
      this.requestService.uploadLogo(this.clienteId, e.target.files[0]).then(function (e) {
        window.location.reload();
        _this14.createNotify("positive", "Logo enviada com sucesso!");
      }).catch(function (_ref13) {
        var data = _ref13.data;
        _this14.createNotify("negative", data.message);
      });
    },
    initColorPicker: function initColorPicker() {
      var _this15 = this;
      var allColors = this.getColors;
      var containerColorsPrimary = document.querySelector(".c-primary");
      var containerColorsSecondary = document.querySelector(".c-secondary");
      if (containerColorsPrimary !== null) {
        var _iterator = _createForOfIteratorHelper(allColors),
          _step;
        try {
          var _loop = function _loop() {
            var color = _step.value;
            var colorDiv = document.createElement("span");
            colorDiv.classList.add("div-color");
            colorDiv.style.backgroundColor = color;
            colorDiv.setAttribute("data-hex", color);
            containerColorsPrimary.appendChild(colorDiv);
            colorDiv.addEventListener("click", function (e) {
              _this15.changeColor(color, "primary");
              colorDiv.parentElement.parentElement.classList.remove("expand-height");
            });
          };
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      if (containerColorsSecondary !== null) {
        var _iterator2 = _createForOfIteratorHelper(allColors),
          _step2;
        try {
          var _loop2 = function _loop2() {
            var color = _step2.value;
            var colorDiv = document.createElement("span");
            colorDiv.classList.add("div-color");
            colorDiv.style.backgroundColor = color;
            colorDiv.setAttribute("data-hex", color);
            containerColorsSecondary.appendChild(colorDiv);
            colorDiv.addEventListener("click", function (e) {
              _this15.changeColor(color, "secondary");
              colorDiv.parentElement.parentElement.classList.remove("expand-height");
            });
          };
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            _loop2();
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    },
    showDialogBox: function showDialogBox(type) {
      if (!["name", "code", "local"].includes(type)) {
        return;
      }
      this.typeCallMessage = type;
      this.showCustomMessageDialog = true;
    },
    closePickerAndAddNew: function closePickerAndAddNew(type) {
      this.showDialogBox(type);
    },
    changeColor: function changeColor(color, element) {
      if (element == "primary") {
        this.painel.primaryColor = color;
      } else if ("secondary") {
        this.painel.secondaryColor = color;
      }
      this.$forceUpdate();
    },
    eventSavingData: function eventSavingData(condition, obj) {
      if (condition) {
        loading("<h5>Salvando...</h5>");
        if (condition.type === undefined) {
          obj.callBy === "name" ? this.nameCallingTextHandler.push(obj) : this.codeCallingTextHandler.push(obj);
        } else {
          this.placeNames.push(obj);
        }
        this.createNotify("positive", "Salvo com sucesso!");
      } else {
        if (Loading.isActive) {
          Loading.hide();
        }
        if (messageObj.error) this.createNotify("negative", "Erro ao salvar!");
      }
    },
    deleteMessage: function deleteMessage(id, type) {
      var _this16 = this;
      loading("<h6>Deletando...</h6>");
      if (type !== "local") {
        if (type === "name") {
          this.nameCallingTextHandler = this.nameCallingTextHandler.filter(function (e) {
            return e.id !== id;
          });
          this.painel.nameCallingText = null;
          this.showNamePicker = false;
        } else if (type === "code") {
          this.codeCallingTextHandler = this.codeCallingTextHandler.filter(function (e) {
            return e.id !== id;
          });
          this.painel.codeCallingText = null;
          this.showCodePicker = false;
        } else {
          return;
        }
        this.requestService.delMessage(id).then(function (_ref14) {
          var data = _ref14.data;
          _this16.savePainelAndMedia(true);
          if (Loading.isActive) Loading.hide();
          if (data === true) {
            _this16.createNotify("positive", "Deletado com sucesso!");
          } else {
            _this16.createNotify("negative", "Não foi possivel deletar!");
          }
        });
      } else {
        this.placeNames = this.placeNames.filter(function (e) {
          return e.id !== id;
        });
        this.painel.placeName = "";
        this.showLocalPicker = false;
        this.requestService.deletePlace(id).then(function (_ref15) {
          var data = _ref15.data;
          _this16.savePainelAndMedia(true);
          if (Loading.isActive) Loading.hide();
          if (data === true) {
            _this16.createNotify("positive", "Deletado com sucesso!");
          } else {
            _this16.createNotify("negative", "Não foi possivel deletar!");
          }
        });
      }
    },
    getVideoYoutubeInfo: function getVideoYoutubeInfo(url) {
      var youtubeURL = new URL(url);
      var code = youtubeURL.searchParams.get("v");
      var list = youtubeURL.searchParams.get("list");
      return {
        code: code,
        list: list
      };
    },
    saveVideoYoutube: function saveVideoYoutube() {
      var _this17 = this;
      loading("<h5>Salvando...</h5>");
      var video_info = this.getVideoYoutubeInfo(this.youtube.uri);
      if (!video_info.code) {
        this.createNotify("negative", "Não foi possível carregar o código do vídeo. Verifique a URL informada e tente novamente.");
        Loading.hide();
        return;
      }
      if (this.youtube.isPlaylist && !video_info.list) {
        this.createNotify("negative", "Não foi possível carregar as informações da playlist. Verifique a URL informada e tente novamente.");
        Loading.hide();
        return;
      }
      var payload = {
        uri: this.youtube.uri,
        code: video_info.code,
        list: video_info.list,
        isPlaylist: this.youtube.isPlaylist
      };
      this.requestService.saveYoutube(payload).then(function (e) {
        _this17.createNotify("positive", "Enviado com sucesso!");
        _this17.showModalYoutube = false;
        _this17.getVideos();
        Loading.hide();
      }).catch(function (_ref16) {
        var data = _ref16.data;
        _this17.createNotify("negative", data.message);
        Loading.hide();
      });
    },
    checkHasVideoYoutube: function checkHasVideoYoutube() {
      return this.allVideos.some(function (video) {
        return video.origin === 'youtube';
      });
    },
    disabledYoutube: function disabledYoutube() {
      return this.checkHasVideoYoutube() || this.allVideos.length > 0;
    }
  })
};